/* eslint-disable no-mixed-spaces-and-tabs */

import React, { Component } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'
import { Button } from 'react-bootstrap'
import { Link} from 'react-router-dom'

import * as Constants from '../../helpers/constants'
import { liveChatsFetched, chatJoined, chatClosed } from './live_chats_reducer'
import { ChatInstance } from './chat'

/* global sfclient */

class LiveChats extends Component {

  constructor(props) {
    super(props)

    this.state = {
      isLiveChatsFetched: false
    }
  }
  componentDidUpdate() {
    if (ChatInstance().chatUser && !this.state.isLiveChatsFetched) {
      this.getLiveChats()
    }
  }

  componentDidMount() {
    if (ChatInstance().chatUser && !this.state.isLiveChatsFetched) {
      this.getLiveChats()
    }
  }

	getLiveChats = () => {
	  let self = this
	  sfclient.chat.getLiveMeetings()
	    .then(function (res) {
	      console.log("Live Meetings... : ", res)
	      self.props.dispatch(liveChatsFetched(res.data))
	      self.setState({
	        isLiveChatsFetched: true
	      })
	    })
	}

	onJoinChat = (meetingId) => {
	  let self = this
	  sfclient.chat.joinMeetingRequest(meetingId)
	    .then(function (res) {
	      if (res.status === Constants.SF_API.Success) {
	        self.props.dispatch(chatJoined(res.data.meeting_details))
	      }
	    })
	}

	meetingClosed = (meetingId) => {
	  this.props.dispatch(chatClosed(meetingId))
	}

	meetingRemoved = (meetingId) => {
	  this.props.dispatch(chatClosed(meetingId))
	}

	render() {

	  return (
	    <div className="bodyContent">
	      <section className="content-header">
	        <h1 style={{ marginBottom: '5px', fontWeight: '600', display: 'inline-block' }}>Live Chats</h1>

	        <div className='pull-right' >
	          <Link to={Constants.FRESHCHAT_URL}  target={'_empty'} >
	            <Button bsStyle="primary" onClick={this.onUserActionsClick} >Click here to Launch FreshChat</Button>

	          </Link>
	        </div>
	      </section>
	      <section className="content">
	        <ChatDataTable liveChats={this.props.liveChats.liveChats}
	          onJoinChat={this.onJoinChat}
	          mqttSubscribed={true}
	          decks={[]} />
	      </section>
	    </div>
	  )
	}
}

class ChatDataTable extends Component {

  constructor(props) {
    super(props)
    this.onClickJoinChat = this.onClickJoinChat.bind(this)
  }

  onClickJoinChat(e) {
    // e.stopPropagation()
    // check if chat already joined with button disabled status, if so dont do anything 
    if (e.target.dataset.disabled === "disabled") {
      return;
    }

    let meetingId = parseInt(e.target.dataset.meetingId, 10)
    this.props.onJoinChat(meetingId)
  }

  render() {
    // filter based on statuses
    const defaultSort = {
      defaultSortName: 'requested_at',
      defaultSortOrder: 'desc'
    }

    function convertTimeToMoments(cell) {
      let timeInMoments = moment(new Date(cell)).fromNow()
      return (
        <span>{timeInMoments}</span>
      )

    }
    const actionFormatter = (cell, row) => {
      // NOTE: here we have used custom data-meeting-id attribute to pass the meeting id
      let meetingId = row.id

      // let joinText = ((this.props.mqttSubscribed[meetingId] === "subscribed" || row.invited_agent_id)) ? "join" : "accept"
      let disable = row.isOpen ? "disabled" : ""
      return (
        <div>
          <button className={`btn btn-xs btn-primary ${disable}`} style={{ float: 'left' }}
            data-meeting-id={meetingId} data-disabled={disable}
            onClick={this.onClickJoinChat}>Join
          </button>&nbsp;
        </div>
      )
    }

    return (
      <div>
        <BootstrapTable
          data={this.props.liveChats}
          options={defaultSort}
          hover={false}
          search={true}
          height={"auto"}
          searchPlaceholder="Search"
          headerStyle={{ border: '0px', background: 'lightgrey' }}
          tableStyle={{ border: '0px', 'background': 'white' }}
          bodyStyle={{ border: '0px', overflow: "auto" }}
        >
          <TableHeaderColumn dataField='client_app_id' dataSort={true} width="130px">App Name</TableHeaderColumn>
          <TableHeaderColumn isKey dataField='id' dataSort={true} width="130px">Meeting ID</TableHeaderColumn>
          <TableHeaderColumn dataField='name' dataSort={true} data width="160px">Name</TableHeaderColumn>
          <TableHeaderColumn dataField='requested_at' dataSort={true} width="100px" dataFormat={convertTimeToMoments}>Requested @</TableHeaderColumn>
          <TableHeaderColumn dataField='action' dataFormat={actionFormatter} width="150px" export={false}>Action</TableHeaderColumn>
        </BootstrapTable>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    liveChats: state.live_chats,
    user: state.userReducer
  }
}

export default connect(mapStateToProps)(LiveChats)


// WEBPACK FOOTER //
// ./src/components/chats/live_chats.js